/**
 * Input data name for use with <ConfigFormBlock>.
 *
 * This shared value keeps the config shapes and input datas passed to the generic step config editor in sync.
 *
 * See `inputDataFrames` and `configShape`, passed from <ConfigFormBlock> to `StepConfigEditorRouterV2>.
 */
export const DATA_LAYOUT_INPUT_DATA_NAME = 'Input dataset';
